import { Duration } from 'luxon'

export const formatVideoLength = (length: number) => {
  const duration = Duration.fromObject({ hours: 0, minutes: 0, seconds: length }).normalize()
  const hours = duration.hours
  const minutes = duration.minutes

  if (!hours) {
    return `${minutes} mins`
  }

  return `${hours} hrs ${minutes} mins`
}
